import React, { FC, ReactNode } from "react"
import { cls } from "../../utils"
import { MiniDeLoading } from "../DeLoading"

type ColumnProps<T> = {
  label: ReactNode
  align?: "center" | "right" | "left" | "justify" | "char"
  classNames?: { cell?: string; td?: string; th?: string }
  render: (row: T & { sn: number }) => ReactNode
}

type Props<T> = {
  columns: ColumnProps<T>[]
  data: T[]
  fetchMore?: () => void
  isLoading?: boolean
}

const AppTable = <T = "unknown",>({
  columns,
  fetchMore,
  data,
  isLoading,
}: Props<T>) => {
  return (
    <div className="h-full rounded-x10 border-spacing-y-10 border-spacing-x-0 overflow-hidden border border-kyzzen-secondary">
      <div
        className="app-table w-full overflow-auto h-full block"
        onScroll={fetchMore}
      >
        <table className="rounded-lg border-separate border-spacing-0 w-full">
          <thead>
            <tr>
              {columns.map((column, idx) => (
                <th
                  key={idx}
                  align={column.align || "left"}
                  className={cls(
                    "px-2.5 py-3 font-medium text-sm whitespace-nowrap group/th text-accent-main border-b border-kyzzen-secondary sticky top-0 bg-kyzzen-primary",
                    column.classNames?.th,
                    column?.classNames?.cell
                  )}
                >
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {isLoading ? (
              <tr>
                <td colSpan={7}>
                  <MiniDeLoading />
                </td>
              </tr>
            ) : (
              data.map((item, idx) => (
                <tr key={idx} className="group/tbr">
                  {columns.map((column, cidx) => (
                    <td
                      key={cidx}
                      align={column.align}
                      className={cls(
                        "px-2.5 py-3 text-sm whitespace-nowrap group/td font-normal border-b border-kyzzen-secondary truncate",
                        "[tr:last-of-type_&]:border-b-0",
                        column.classNames?.td,
                        column.classNames?.cell
                      )}
                    >
                      {column.render({ ...item, sn: idx + 1 })}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default AppTable
